module.exports = __webpack_public_path__ + "img/web-white.fe9febb3.png";